import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import {
  useUsageLimitControllerAdminUsageLimitsQuery,
  UsageUnitLimit,
} from '@shared/services/apiService/apiService';
import { CustomTooltip } from '@shared/components/customTooltip';
import { formatCompactUsagePair } from '@shared/utils/formatCompactCount';
import { formatUsedLimitPairAsHours } from '@widgets/Popup/CompanyLimitsPopup/utils';

export type UsageLimitRatioCellMode = 'hours' | 'tokens';

interface UsageLimitRatioCellProps {
  companyId: string;
  unit: UsageUnitLimit;
  mode: UsageLimitRatioCellMode;
}

export const UsageLimitRatioCell: React.FC<UsageLimitRatioCellProps> = ({
  companyId,
  unit,
  mode,
}) => {
  const { data, isLoading } = useUsageLimitControllerAdminUsageLimitsQuery({ id: companyId });

  if (isLoading) {
    return <CircularProgress size={14} />;
  }

  const row = data?.limits?.find((item) => item.unit === unit);
  if (!row) {
    return <Typography variant="body2">—</Typography>;
  }

  if (mode === 'hours') {
    const text = formatUsedLimitPairAsHours(row.used, row.limit);
    return <Typography variant="body2">{text}</Typography>;
  }

  const { short, full } = formatCompactUsagePair(row.used, row.limit);

  return (
    <CustomTooltip title={full} placement="top" arrow>
      <Typography variant="body2" component="span" sx={{ cursor: 'default' }}>
        {short}
      </Typography>
    </CustomTooltip>
  );
};
